export default __webpack_public_path__ + "static/media/ge7.5e9b5e90.jpg";